import * as React from 'react';

export const DeleteIcon = ({ onClick, className }) => {
  return (
    <svg
      className={className}
      onClick={onClick}
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path d='M1.00659 1.00674L14.9999 15.0001' stroke='#3023AE' strokeWidth='2' strokeMiterlimit='10' />
      <path d='M14.9999 1.00674L1.00659 15.0001' stroke='#3023AE' strokeWidth='2' strokeMiterlimit='10' />
    </svg>
  );
};
